import Script from 'next/script'
import { useFeatureFlips } from '@mc/feature-flip-react'

export const ContentSquare = () => {
  const { 'contentsquare-script': enabled } = useFeatureFlips()

  if (!enabled) return null

  return <Script src='https://t.contentsquare.net/uxa/8014a7a46472d.js' />
}
